import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import axios from 'axios';
import { constants } from '../config/constants';
import { setLogOut } from '../store/auth';
// @ts-ignore
import { persistor } from '../store/store.js';

export const LogOut = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const performLogout = async () => {
      try {
        const cookieName = constants.zynity_api_access_token_cookie_name;
        if (cookieName) {
          const host = window.location.hostname;
          const cookieDomains = new Set<string>();

          if (host) {
            cookieDomains.add(host);
          }
          if (host === 'zynity.com' || host.endsWith('.zynity.com')) {
            cookieDomains.add('zynity.com');
            cookieDomains.add('.zynity.com');
          }

          Cookies.remove(cookieName, { path: '/' });
          Cookies.remove(cookieName);

          cookieDomains.forEach((domain) => {
            Cookies.remove(cookieName, { path: '/', domain });
            Cookies.remove(cookieName, { domain });
          });
        }
        delete axios.defaults.headers.common.Authorization;
        dispatch(setLogOut());
        localStorage.removeItem(constants.post_login_redirect_storage_key);
      } catch {
        // swallow clean-up errors
      }

      try {
        persistor.pause();
        await persistor.flush();
        await persistor.purge();
      } catch {
        // ignore persist errors during logout
      }

      // Stay within this app instead of bouncing to the external Yii login.
      navigate('/');
    };

    performLogout();
  }, [dispatch, navigate]);

  return null;
};
